import { useState, useCallback } from 'react'

import { CatalogItem } from 'types/model'

interface State {
  available: CatalogItem[]
  taken: CatalogItem[]
}

export default function useIterateUpsells() {
  const [state, setState] = useState<State>({
    available: [],
    taken: [],
  })

  const { available, taken } = state
  const current = available.length > 0 ? available[0] : undefined

  return {
    current,
    available,
    taken,

    init: useCallback((upsells: CatalogItem[]) => {
      setState({
        available: upsells,
        taken: [],
      })
    }, []),

    next: useCallback(
      (isTaken: boolean) => {
        setState((p) => {
          if (!current) {
            return p
          }

          let { available, taken } = p
          if (isTaken) {
            // Push current on to the taken array
            taken = [...taken, current]
          }

          // Now remove current from available
          available = available.filter((_, i: number) => i !== 0)

          return {
            available,
            taken,
          }
        })
      },
      [current]
    ),
  }
}
